var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut03 = function SvgLogOut03(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.25,
    d: "m16 7 5 5-5 5m5-5H9m3 5c0 .296 0 .443-.011.571a3 3 0 0 1-2.404 2.686 7 7 0 0 1-.567.074l-1.021.114c-1.535.17-2.302.256-2.911.06a3 3 0 0 1-1.825-1.633C3 18.289 3 17.516 3 15.972V8.028c0-1.544 0-2.316.261-2.9a3 3 0 0 1 1.825-1.633c.61-.196 1.376-.11 2.91.06l1.022.114c.294.032.441.049.567.074a3 3 0 0 1 2.404 2.686C12 6.557 12 6.704 12 7",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgLogOut03;